module.exports = __webpack_public_path__ + "img/mec-logo.3cbd32a5.svg";